import KidoAPIInstance from "../../services/KidoConfigApi";

export const getGiftExchangePointApi = async params => {
	const path = `api/loyalty/getExchangePoint?business=${params?.business}&loyaltyId=${params?.loyaltyId}`;
	return await KidoAPIInstance.get(path);
};

export const postCreateOrderExchangePointApi = async data => {
	const path = "api/loyalty/createOrderExchangePoint";
	return await KidoAPIInstance.post(path, data);
};
